<template>
    <div class="consultant-team">
        <el-table :data="consultants" border stripe :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}" size="mini">
            <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
            <el-table-column prop="teamtype" label="团队类型" ></el-table-column>
            <el-table-column prop="name" label="名称" ></el-table-column>
            <el-table-column prop="telephone" label="手机" show-overflow-tooltip></el-table-column>
            <el-table-column prop="team.name" label="团队" show-overflow-tooltip></el-table-column>
            <el-table-column prop="company" label="公司" show-overflow-tooltip></el-table-column>
            <el-table-column prop="zixunlen" label="咨询人数" ></el-table-column>
            <el-table-column prop="addDate" label="加入时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="putaway" label="状态" align="center">
                <template slot-scope="s">
                    <span v-if="s.row.putaway==true" class="text text-success">上架中</span>
                    <span v-else class="text text-warning">下架中</span>
                </template>
            </el-table-column>
            <el-table-column prop="admin" label="操作" width="168">
                <template slot-scope="s">
                    <el-button v-if="s.row.putaway==true" type="warning" size="mini" @click="putaway(s.row, s.$index, false)">下架</el-button>
                    <el-button v-else type="success" size="mini"  @click="putaway(s.row, s.$index, true)">上架</el-button>
                    <el-button type="primary" size="mini" plain @click="todetail(s.row)">查看详情</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    name: 'ConsultantCell',
    data() {
        return {

        }
    },
    props: {
        consultants: {
            type: Array,
            default: function() {
                return [1,2,3,3,4,423,5,5,5,6,66,6];
            },
        },
    },
    methods: {
        todetail(item) {
            this.$router.push({path: '/project/user/detail', query: {uid: item.uid}})
        },
        putaway(item, index, putaway) {
            var params = {
                id: item._id['$oid'],
                putaway
            }
            this.$api.consultantPutawayVsId(params).then(
                data=>{
                    this.$message.success(data);
                    this.consultants[index].putaway = putaway;
                }
            )
        }
    },
}
</script>

<style lang="scss" scoped>

</style>